class VideoCarousel extends HTMLElement {
	constructor() {
		super();
		this.itemsContainer = this.querySelector('ul');
		this.items = [...this.querySelectorAll('li')];

		// On Safari iOS, changes to transform on scroll are delayed, so turn off the '3D' effect
		let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
		if (isSafari) this.classList.add('disable-3d');

		for (let [idx, item] of this.items.entries()) {
			item.querySelector('.video-carousel__inner').addEventListener('click', e => {
				item.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'center'});
			});

			item.querySelector('video').controls = false;
			item.querySelector('video').addEventListener('click', e => {
				let video = e.currentTarget;
				if (video.paused) {
					item.dataset.playing = true;
					item.dataset.played = true;
					video.play();
				}
				else {
					item.dataset.playing = false;
					video.pause();
				}
			});
		}
		
		this.itemsContainer.addEventListener('scroll', e => {
			this.calculateIndex();
		}, { passive: true });
	}

	connectedCallback() {
		setTimeout(() => {
			this.itemsContainer.style.removeProperty('--offset');
			this.itemsContainer.scrollLeft = 250;
			this.calculateIndex();
		}, 100);
	}


	calculateIndex() {
		this.items.forEach((item, idx) => {
			// Calculate distance from center
			let dist = item.offsetLeft - this.itemsContainer.scrollLeft;
			dist += item.offsetWidth / 2;
			dist -= this.offsetWidth / 2;

			let ratio = dist / item.offsetWidth;
			item.style.setProperty('--index', ratio);

			if (ratio > -0.5 && ratio < 0.5) {
				if (!item.classList.contains('active')) {
					item.classList.add('active');
					item.classList.add('transition-in');
					setTimeout(() => item.classList.remove('transition-in'), 500);
				}
			}
			else {
				if (item.classList.contains('active')) {
					item.classList.add('transition-out');
					item.classList.remove('active');
					item.querySelector('video').pause();
					item.dataset.playing = false;
					
					setTimeout(() => {
						item.classList.remove('transition-out');
					}, 500);
				}
			}


			if (ratio > -0.4) {
				item.style.zIndex = this.items.length - idx;
			}
			else item.style.zIndex = '';
		});
	}
}

customElements.define('video-carousel', VideoCarousel);